import React, { Component } from 'react';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import moment from 'moment';

import style from './style.scss';

import EventCourseSummary from '../EventCourseSummary';

import { courseTypeToLabel } from '../../services/courseTypeLabelMapper';
import eventFormatter from '../../services/eventFormatter';
import marketingListItemTypes from "../../services/constants/marketingListItemTypes";

import * as marketingActions from "../../actions/marketingPage";
import sessions from "../../services/sessions";

class UpcomingEventsCourses extends Component {

    componentDidMount() {
        this.props.getMarketingList();
    }

    render() {
        const { marketingList } = this.props;

        // Check for events that have already finished and remove them
        marketingList.forEach((item, i) => {
            if(item.marketable_type === 'App\\Models\\Event'){
                if(item.marketable.multiple_days){
                    if(moment(item.marketable.multiple_days_events[item.marketable.multiple_days_events.length - 1].end_date).isBefore(moment())){
                        marketingList.splice(i, 1);
                    }
                }else{
                    if(moment(item.marketable.end_date).isBefore(moment())){
                        marketingList.splice(i, 1);
                    }
                }
            }
        });

        if(marketingList.length > 0){
            
            return (

                <article className={style['upcoming-events']}>

                    <div className={style['section-content']}>

                        <h2 styleName="section-heading--light">Featured</h2>

                        <div className={style['events-list']}>
                            {marketingList.map((event, index) => {
                                let hexColor,
                                    courseType,
                                    courseName,
                                    courseAddress = null;
                                let hideBookNow = false;

                                if(event.marketable_type === marketingListItemTypes.course.className){
                                    hexColor = event.marketable.module.hex_colour;
                                    courseType = courseTypeToLabel(event.marketable.type);
                                    courseName = event.marketable.name;
                                    hideBookNow = !event.marketable.elearning_course_id;
                                }else{
                                    hexColor = event.marketable.course.module.hex_colour;
                                    courseType = "Event";
                                    courseName = event.marketable.course_name;
                                    courseAddress = event.marketable.course.type === 'webinar' ? '' : event.marketable.venue.address.town_city;
                                }

                                const formattedEvent = eventFormatter.format(event.marketable);

                                if(index <= 5) {
                                    return (
                                        <EventCourseSummary
                                            className={ style['featured-event'] }
                                            inHouse={ false }
                                            event={event}
                                            moduleHexColour={hexColor}
                                            hideBookNow={ hideBookNow }
                                        >

                                            <span styleName="featured-event__course-type-heading">
                                                { courseType }
                                            </span>

                                            <span styleName="featured-event__course-name-heading">
                                                {courseName}
                                            </span>

                                            {sessions(formattedEvent, eventFormatter.getFormattedEventDate)}

                                            {(!event.marketable.multiple_days && event.marketable_type === 'App\\Models\\Event') && (
                                                <span styleName="featured-event__date">{eventFormatter.getFormattedEventDate(event.marketable)}</span>
                                            )}

                                            <span styleName="featured-event__venue">{courseAddress}</span>

                                        </EventCourseSummary>
                                    );
                                }
                            })}
                        </div>
                    </div>

                </article>
            );
        }else{
            return null;
        }

    }
}

function mapStateToProps(state) {
    return {
        marketingList: state.marketingPage.marketingList
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getMarketingList(){
            dispatch(marketingActions.getMarketingList());
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(UpcomingEventsCourses, style));


// WEBPACK FOOTER //
// ./components/UpcomingEventsCourses/index.js